import React, { PureComponent } from 'react';
import Collapsible from 'react-collapsible';
import { arraysEqual } from '../../../../../helpers/arrayUtils';


class Budget extends PureComponent {

  constructor(){
    super();

    this.state = {
      accordionOpen:true,
      accordiontransitionTime:300,
      activeFilter:""
    }
  }


  static getDerivedStateFromProps(nextProps, prevState){
     if(nextProps.active !== prevState.activeFilter){
        return {
          activeFilter:nextProps.active
        }
     }
     return null;
  }


  onBudgetClick(e, budgetArr, budgetText){
    e.preventDefault();

    if(this.props.currencyReady){
      this.props.onSelect(budgetArr, budgetText);
    }
  }


  setActiveFilter(currentItem){
    return arraysEqual(currentItem, this.state.activeFilter) ? 'active-filter' : "";
  }

  render(){

    const currency = (this.props.currency && this.props.currency !== undefined) ? this.props.currency : "";

    return (
       <Collapsible
         trigger="Budget"
         open={this.state.accordionOpen}
         transitionTime={this.state.accordiontransitionTime}>

        <div className="filter-buttons">
          <div className="row">
            <div className="columns small-12 medium-6 no-pad-right"><button className={this.setActiveFilter([0,750])} onClick={e => this.onBudgetClick(e, [0,750], `Below ${currency.charAt(0)}750`) }>Below {currency.charAt(0)}750</button></div>
            <div className="columns small-12 medium-6 no-pad-left"><button className={this.setActiveFilter([750,1500])} onClick={e => this.onBudgetClick(e, [750,1500], `${currency.charAt(0)}750 - ${currency.charAt(0)}1,500`) }>{currency.charAt(0)}750 - {currency.charAt(0)}1,500</button></div>
            <div className="columns small-12 medium-6 no-pad-right no-margin"><button className={this.setActiveFilter([1500,2000])} onClick={e => this.onBudgetClick(e, [1500,2000], `${currency.charAt(0)}1,500 - ${currency.charAt(0)}2,000`) }>{currency.charAt(0)}1,500 - {currency.charAt(0)}2,000</button></div>
            <div className="columns small-12 medium-6 no-pad-left no-margin"><button className={this.setActiveFilter([2000,8000])} onClick={e => this.onBudgetClick(e, [2000,8000], `Over ${currency.charAt(0)}2,000`) }>Over {currency.charAt(0)}2,000 </button></div>
          </div>
        </div>

      </Collapsible>
    )
  }

}

export default Budget;



// WEBPACK FOOTER //
// ./src/components/search/components/filters/components/budget.js